import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {FabricPositionalParams} from '@Utils/fabric.util';

interface StateProps {
  openPosterPopUpMenu: boolean;
  popUpPosition: FabricPositionalParams | undefined;
  target: any | undefined;
  eventCanvasOffset: FabricPositionalParams | undefined;
  /** Set when the menu opens from a right-click on the empty timeline area; routes to a paste-only menu instead of the full canvas menu (both have an undefined target). */
  isTimelineContextMenu?: boolean;
  /** Set when the menu opens from a right-click on a timeline item bar (not the canvas). Gates timeline-only actions like Split. */
  isTimelineItemContextMenu?: boolean;
}

const initialState: StateProps = {
  openPosterPopUpMenu: false,
  popUpPosition: undefined,
  target: undefined,
  eventCanvasOffset: undefined,
  isTimelineContextMenu: false,
  isTimelineItemContextMenu: false,
};

const PosterPopUpMenu = createSlice({
  name: 'PosterPopUpMenu',
  initialState,
  reducers: {
    updatePopUpStateAndPosition: (state: StateProps, action: PayloadAction<StateProps>) => {
      state.openPosterPopUpMenu = action.payload.openPosterPopUpMenu;
      state.popUpPosition = action.payload.popUpPosition;
      state.target = action.payload.target;
      state.eventCanvasOffset = action.payload.eventCanvasOffset;
      state.isTimelineContextMenu = action.payload.isTimelineContextMenu ?? false;
      state.isTimelineItemContextMenu = action.payload.isTimelineItemContextMenu ?? false;
    },
  },
});

export const {updatePopUpStateAndPosition} = PosterPopUpMenu.actions;
export const PosterPopUpMenuReducer = PosterPopUpMenu.reducer;
